export class SetOrderIsImporter {
	static readonly type = '[Quality] SetOrderIsImporter';
	constructor(public isOrderImporter: boolean) {}
}
